import { SHARED_FILTERS } from './send-mail-stepper-shared-filters';

export const MAILING_GROUP_CRM = {
  path: '/mailing/groups/add',
  filters: SHARED_FILTERS
};